var _g, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.71,
    height: 21.59,
    viewBox: "0 0 21.71 21.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "clue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clue"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.3,11a10.25,10.25,0,0,1,20.5,0A10.2,10.2,0,0,1,11.5,21.2,10.18,10.18,0,0,1,1.3,11Zm1.5,0a8.8,8.8,0,1,0,8.8-8.8A8.81,8.81,0,0,0,2.8,11Z",
    transform: "translate(-1.2 -0.71)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5,22l-2-2a.78.78,0,0,1,1.1-1.1l2,2a.78.78,0,0,1,0,1.1c-.2.1-.3.2-.5.2A.85.85,0,0,1,21.5,22Z",
    transform: "translate(-1.2 -0.71)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.19
  })), /*#__PURE__*/React.createElement("path", {
    d: "M7.56,16.65,6.8,16.4h0a2.43,2.43,0,0,1-1.5-2.7,3.81,3.81,0,0,1,1-2c.5-.6,1-1.1,1.5-1.7a13,13,0,0,0,1-1.5,8.67,8.67,0,0,1,3.4-2.9A5.42,5.42,0,0,1,14.7,5a3,3,0,0,1,2.9,3.1,5.38,5.38,0,0,1-.9,2.5,7.9,7.9,0,0,1-3.6,2.9,10.08,10.08,0,0,0-1.8.9,1.21,1.21,0,0,0-.5.5A5.12,5.12,0,0,1,9,16.3c-.3.1-.5.2-.8.3Zm9-8.85A1.68,1.68,0,0,0,15.1,6a3.52,3.52,0,0,0-2,.3,6.27,6.27,0,0,0-2.9,2.2c-.6.7-1.1,1.5-1.6,2.2-.1.1,0,.1,0,.2.8.7,1.5,1.5,2.3,2.2.1.1.1.1.2,0a10.62,10.62,0,0,0,1.7-.8,11.58,11.58,0,0,0,3.14-2.68,3.12,3.12,0,0,0,.61-1.32A2.66,2.66,0,0,0,16.6,7.8ZM7.9,11.6l-.54.59-.46.51a2.05,2.05,0,0,0-.28.46,2.74,2.74,0,0,0-.16.65,1.48,1.48,0,0,0,.09.72,1.58,1.58,0,0,0,1,.87,1.74,1.74,0,0,0,.59,0A1.92,1.92,0,0,0,9.1,15a5.73,5.73,0,0,0,1.1-1.1.19.19,0,0,0,0-.3c-.6-.5-1.1-1.1-1.7-1.6l-.28-.19Z",
    transform: "translate(-1.2 -0.71)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.49
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.91,6.72",
    transform: "translate(-1.2 -0.71)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5,18",
    transform: "translate(-1.2 -0.71)",
    fill: "none",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.53,23.3",
    transform: "translate(-1.2 -0.71)",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.63,15.41",
    transform: "translate(-1.2 -0.71)",
    fill: "{props.color}",
    stroke: "{props.color}",
    strokeMiterlimit: 10,
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClue);
export default __webpack_public_path__ + "static/media/clue.af55a76b71ffc523310bdeed56874a3c.svg";
export { ForwardRef as ReactComponent };